/* eslint-disable max-len */
import React from 'react';

export const ListPollIcon = props => (
  <svg width="62" height="52" viewBox="0 0 62 52" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0H1366V1044H0z" transform="translate(-397 -412)" />
      <g>
        <path fill="#FFF" d="M0 0H940V1H0z" transform="translate(-397 -412) translate(213 418)" />
        <path
          stroke="#000"
          strokeOpacity=".2"
          d="M0.5 0.5H939.5V1.5H0.5z"
          transform="translate(-397 -412) translate(213 418)"
        />
      </g>
      <path fill="#000" fillOpacity=".5" d="M0 0H1366V2042H0z" transform="translate(-397 -412)" />
      <g transform="translate(-397 -412) translate(260 177)">
        <rect width="652" height="497" x=".5" y=".5" fill="#FFF" stroke="#E6E6E6" rx="2" />
      </g>
      <g>
        <path
          fill="#FFF"
          stroke="#B2B3B4"
          strokeOpacity=".745"
          d="M140.471 216.5l-6.052 6.81-6.74-6.81h12.792zM448 .5c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06h0v212c0 .414-.168.79-.44 1.06-.27.272-.646.44-1.06.44h0-305.301l.441-.495h-18.227l.438.494L2 215.5c-.362 0-.695-.129-.954-.343l-.107-.096C.668 214.789.5 214.414.5 214h0V2c0-.414.168-.79.44-1.06C1.21.667 1.585.5 2 .5h0z"
          transform="translate(-397 -412) translate(344 326)"
        />
        <path
          fill="#EBBA4D"
          fillOpacity=".2"
          d="M24 66H150V192H24z"
          transform="translate(-397 -412) translate(344 326)"
        />
      </g>
      <g>
        <path fill="#FFF" d="M0 0H62V52H0z" transform="translate(-397 -412) translate(397 412)" />
        <g>
          <path
            fill="#C1C1C1"
            d="M0 16H43V18H0zM0 20H43V22H0zM0 24H43V26H0z"
            transform="translate(-397 -412) translate(397 412) translate(9 13)"
          />
          <path
            fill="#D9D9D9"
            d="M4 4H41V6H4zM13 0H32V2H13z"
            transform="translate(-397 -412) translate(397 412) translate(9 13)"
          />
        </g>
      </g>
    </g>
  </svg>
);
